var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlankProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.2,
    y: 10,
    width: 231.6,
    height: 231.6,
    rx: 8,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.4 184.008L161.417 157.242C160.2 156.025 158.983 155.417 157.158 155.417H104.842C103.017 155.417 101.8 156.025 100.583 157.242L72.6 184.008L64.0833 175.492L92.0666 148.725C95.1083 145.075 99.975 143.25 104.842 143.25H157.158C162.025 143.25 166.283 145.075 169.933 148.725L197.917 175.492L189.4 184.008Z",
    fill: "#00C256"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131 131.083C112.142 131.083 96.325 115.875 96.325 96.4083C96.325 76.9417 112.142 61.7333 131 61.7333C149.858 61.7333 165.675 77.55 165.675 96.4083C165.675 115.267 149.858 131.083 131 131.083ZM131 73.9C118.833 73.9 108.492 84.2417 108.492 96.4083C108.492 108.575 118.833 118.917 131 118.917C143.167 118.917 153.508 108.575 153.508 96.4083C153.508 84.2417 143.167 73.9 131 73.9Z",
    fill: "#00C256"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0.199951,
    y: 0,
    width: 257.6,
    height: 257.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.75375 0 0 0 0 0.816562 0 0 0 0 0.8375 0 0 0 0.67 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.666667 0 0 0 0 0.756863 0 0 0 0 0.713726 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankProfile);
export default __webpack_public_path__ + "static/media/blankProfile.1afc37cd337e76c65a3751f125fd1fdd.svg";
export { ForwardRef as ReactComponent };